import React, { Component, Fragment } from "react";
import "./sizing.css";
import DropDownWhiteStyle from "../../components/dropdown/dropDownWhiteStyle";
import { Link } from "react-router-dom";

import {
    getScrewOilFreeFlowByInletPressure,
    getScrewOilFreeFlow,
    getScrewOilFreeOutletPressure,
    getCoolingTypes
} from "../../constants/sizing-constant";

export default class AirScrewOilFree extends Component {

    state = {
        inputFlow: [],
        outletPressure: [],
        coolingTypes: [],
        selectedInputFlow: "0",
        selectedOutletPressure: "0",
        selectedCoolingType: "0",
        suggestedModel: "",
        suggestedModelId: "",
        sentrifuge: []
    };

    componentDidMount() {
        this.setState({ outletPressure: [...getScrewOilFreeOutletPressure()] });
        this.setState({ coolingTypes: [...getCoolingTypes()] });
    };

    componentWillReceiveProps(Values) {
        this.setState({ products: Values.products });
    };

    handleOutletPressure = outletPressure => {
        if (outletPressure) {
            this.setState({ selectedOutletPressure: outletPressure.value }, () => {
                this.fillInputFlow();
                this.findModel();
            });
        }
    };

    handleInputFlow = inputFlow => {
        if (inputFlow) {
            this.setState({ selectedInputFlow: inputFlow.value }, () => {
                this.findModel();
            });
        }
    };

    handleCoolingTypesSelect = coolingType => {
        if (coolingType) {
            this.setState({ selectedCoolingType: coolingType.value }, () => {
                this.findModel();
            });
        }
    }

    fillInputFlow() {
        const selectedOutletPressure = this.state.selectedOutletPressure;
        if (selectedOutletPressure === "1") {
            this.setState({ inputFlow: [...getScrewOilFreeFlowByInletPressure(selectedOutletPressure)] });
        }
        if (selectedOutletPressure === "2") {
            this.setState({ inputFlow: [...getScrewOilFreeFlowByInletPressure(selectedOutletPressure)] });
        }
        if (selectedOutletPressure === "3") {
            this.setState({ inputFlow: [...getScrewOilFreeFlowByInletPressure(selectedOutletPressure)] });
        }
    }

    findModel() {
        const selectedOutletPressure = this.state.selectedOutletPressure;
        const selectedInputFlow = this.state.selectedInputFlow;
        const selectedCoolingType = this.state.selectedCoolingType;
        if (selectedOutletPressure === "1") {
            if (selectedInputFlow === "1") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-45" });
                    this.setState({ suggestedModelId: "259" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-45" });
                    this.setState({ suggestedModelId: "260" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-45 یا HFA-45" });
                    this.setState({ suggestedModelId: "261" });
                }
            }
            else if (selectedInputFlow === "2" ) {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-55" });
                    this.setState({ suggestedModelId: "262" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-55" });
                    this.setState({ suggestedModelId: "263" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-55 یا HFA-55" });
                    this.setState({ suggestedModelId: "264" });
                }
            }
            else if (selectedInputFlow === "3") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-75" });
                    this.setState({ suggestedModelId: "265" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-75" });
                    this.setState({ suggestedModelId: "266" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-75 یا HFA-75" });
                    this.setState({ suggestedModelId: "267" });
                }
            }
            else if (selectedInputFlow === "4") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-90" });
                    this.setState({ suggestedModelId: "268" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-90" });
                    this.setState({ suggestedModelId: "269" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-90 یا HFA-90" });
                    this.setState({ suggestedModelId: "270" });
                }
            }
            else if (selectedInputFlow === "5") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-110" });
                    this.setState({ suggestedModelId: "271" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-110" });
                    this.setState({ suggestedModelId: "272" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-110 یا HFA-110" });
                    this.setState({ suggestedModelId: "273" });
                }
            }
            else if (selectedInputFlow === "6") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-132" });
                    this.setState({ suggestedModelId: "274" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-132" });
                    this.setState({ suggestedModelId: "275" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-132 یا HFA-132" });
                    this.setState({ suggestedModelId: "176" });
                }
            }
            else if (selectedInputFlow === "7") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-160" });
                    this.setState({ suggestedModelId: "277" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-160" });
                    this.setState({ suggestedModelId: "278" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-160 یا HFA-160" });
                    this.setState({ suggestedModelId: "279" });
                }
            }
            else if (selectedInputFlow === "8") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-200" });
                    this.setState({ suggestedModelId: "280" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-200" });
                    this.setState({ suggestedModelId: "281" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-200 یا HFA-200" });
                    this.setState({ suggestedModelId: "282" });
                }
            }
            else if (selectedInputFlow === "9") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-250" });
                    this.setState({ suggestedModelId: "283" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-250" });
                    this.setState({ suggestedModelId: "284" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-250 یا HFA-250" });
                    this.setState({ suggestedModelId: "285" });
                }
            }
            else if (selectedInputFlow === "10") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-315" });
                    this.setState({ suggestedModelId: "286" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-315" });
                    this.setState({ suggestedModelId: "287" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-315 یا HFA-315" });
                    this.setState({ suggestedModelId: "288" });
                }
            }
        }
        if (selectedOutletPressure === "2") {
            if (selectedInputFlow === "1") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-55" });
                    this.setState({ suggestedModelId: "262" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-55" });
                    this.setState({ suggestedModelId: "263" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-55 یا HFA-55" });
                    this.setState({ suggestedModelId: "264" });
                }
            }
            else if (selectedInputFlow === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-75" });
                    this.setState({ suggestedModelId: "265" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-75" });
                    this.setState({ suggestedModelId: "266" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-75 یا HFA-75" });
                    this.setState({ suggestedModelId: "267" });
                }
            }
            else if (selectedInputFlow === "3") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-90" });
                    this.setState({ suggestedModelId: "268" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-90" });
                    this.setState({ suggestedModelId: "269" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-90 یا HFA-90" });
                    this.setState({ suggestedModelId: "270" });
                }
            }
            else if (selectedInputFlow === "4") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-110" });
                    this.setState({ suggestedModelId: "271" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-110" });
                    this.setState({ suggestedModelId: "272" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-110 یا HFA-110" });
                    this.setState({ suggestedModelId: "273" });
                }
            }
            else if (selectedInputFlow === "5") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-132" });
                    this.setState({ suggestedModelId: "274" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-132" });
                    this.setState({ suggestedModelId: "275" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-132 یا HFA-132" });
                    this.setState({ suggestedModelId: "176" });
                }
            }
            else if (selectedInputFlow === "6") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-160" });
                    this.setState({ suggestedModelId: "277" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-160" });
                    this.setState({ suggestedModelId: "278" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-160 یا HFA-160" });
                    this.setState({ suggestedModelId: "279" });
                }
            }
            else if (selectedInputFlow === "7") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-200" });
                    this.setState({ suggestedModelId: "280" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-200" });
                    this.setState({ suggestedModelId: "281" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-200 یا HFA-200" });
                    this.setState({ suggestedModelId: "282" });
                }
            }
            else if (selectedInputFlow === "8") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-250" });
                    this.setState({ suggestedModelId: "283" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-250" });
                    this.setState({ suggestedModelId: "284" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-250 یا HFA-250" });
                    this.setState({ suggestedModelId: "285" });
                }
            }
            else if (selectedInputFlow === "9") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-315" });
                    this.setState({ suggestedModelId: "286" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-315" });
                    this.setState({ suggestedModelId: "287" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-315 یا HFA-315" });
                    this.setState({ suggestedModelId: "288" });
                }
            }
        }
        if (selectedOutletPressure === "3") {
            if (selectedInputFlow === "1") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-55" });
                    this.setState({ suggestedModelId: "259" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-55" });
                    this.setState({ suggestedModelId: "260" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-55 یا HFA-55" });
                    this.setState({ suggestedModelId: "261" });
                }
            }
            else if (selectedInputFlow === "2") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-75" });
                    this.setState({ suggestedModelId: "265" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-75" });
                    this.setState({ suggestedModelId: "266" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-75 یا HFA-75" });
                    this.setState({ suggestedModelId: "267" });
                }
            }
            else if (selectedInputFlow === "3") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-90" });
                    this.setState({ suggestedModelId: "268" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-90" });
                    this.setState({ suggestedModelId: "269" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-90 یا HFA-90" });
                    this.setState({ suggestedModelId: "270" });
                }
            }
            else if (selectedInputFlow === "4") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-110" });
                    this.setState({ suggestedModelId: "271" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-110" });
                    this.setState({ suggestedModelId: "272" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-110 یا HFA-110" });
                    this.setState({ suggestedModelId: "273" });
                }
            }
            else if (selectedInputFlow === "5") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-132" });
                    this.setState({ suggestedModelId: "274" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-132" });
                    this.setState({ suggestedModelId: "275" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-132 یا HFA-132" });
                    this.setState({ suggestedModelId: "176" });
                }
            }
            else if (selectedInputFlow === "6") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-160" });
                    this.setState({ suggestedModelId: "277" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-160" });
                    this.setState({ suggestedModelId: "278" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-160 یا HFA-160" });
                    this.setState({ suggestedModelId: "279" });
                }
            }
            else if (selectedInputFlow === "7") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-200" });
                    this.setState({ suggestedModelId: "280" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-200" });
                    this.setState({ suggestedModelId: "281" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-200 یا HFA-200" });
                    this.setState({ suggestedModelId: "282" });
                }
            }
            else if (selectedInputFlow === "8") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-250" });
                    this.setState({ suggestedModelId: "283" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-250" });
                    this.setState({ suggestedModelId: "284" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-250 یا HFA-250" });
                    this.setState({ suggestedModelId: "285" });
                }
            }
            else if (selectedInputFlow === "9") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-315" });
                    this.setState({ suggestedModelId: "286" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-315" });
                    this.setState({ suggestedModelId: "287" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-315 یا HFA-315" });
                    this.setState({ suggestedModelId: "288" });
                }
            }
            else if (selectedInputFlow === "10") {
                if (selectedCoolingType === "1") {
                    this.setState({ suggestedModel: "HFW-315" });
                    this.setState({ suggestedModelId: "286" });
                }
                else if (selectedCoolingType === "2") {
                    this.setState({ suggestedModel: "HFA-315" });
                    this.setState({ suggestedModelId: "287" });
                }
                else {
                    this.setState({ suggestedModel: "HFW-315 یا HFA-315" });
                    this.setState({ suggestedModelId: "288" });
                }
            }
        }
    }

    render() {
        return (
            <Fragment>
                <DropDownWhiteStyle
                    items={this.state.outletPressure}
                    placeholder="فشار خروجی کمپرسور (برحسب بار گیج)"
                    onItemSelect={this.handleOutletPressure}
                />
                {this.state.selectedOutletPressure !== "0" &&
                        <DropDownWhiteStyle
                            items={this.state.inputFlow}
                            placeholder="ظرفیت ورودی کمپرسور (برحسب مترمکعب بر ساعت)"
                            onItemSelect={this.handleInputFlow}
                        />
                }
                {this.state.selectedInputFlow !== "0" &&
                    <DropDownWhiteStyle
                        items={this.state.coolingTypes}
                        placeholder="نوع خنک کننده"
                        onItemSelect={this.handleCoolingTypesSelect}
                    />
                }
                {this.state.suggestedModel !== "" &&
                    <Fragment>
                        <h1 className="text-title-body">مدل پیشنهادی برای شما :</h1>
                        <div className="modelheadbox">
                            <h1 >{this.state.suggestedModel}</h1>
                            <hr className="divider" />
                        </div>
                        <h3 className="text-title-description"> پیشنهاد این مدل کمپرسور بر اساس شرایط محل نصبی، با فشار ۱ barA و دمای ۲۰  درجه سانتی گراد انجام شده است</h3>
                        <div className="row hrow mt-4">
                            <Link className="btn btn-dark" to={`/partRequst/${this.state.suggestedModelId}`} >درخواست خرید این مدل</Link>
                        </div>
                    </Fragment>
                }
            </Fragment>
        );
    }
}
